<div class="col-xs-12 col-sm-12 col-md-12 Registration-split recovery-split">
  <form [formGroup]="passwordResetForm" (ngSubmit)="submitpasswordResetForm()">
    <h3 class="login-help-title margin-top0">
      {{ "forgotUserPassword.resetPassword" | cxTranslate }}
    </h3>
    <div class="col-xs-12 col-sm-8 col-md-8 p0">
      <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container Fields-container-error">
        <label id="address2" class="Fields-label">{{
          "forgotUserPassword.emailAddress" | cxTranslate
        }}</label>
        <input type="text" class="Fields-input" formControlName="email" id="email" name="email" (ngModelChange)="validatepasswordReset()" />
        @if (passwordResetForm.get('email').hasError('pattern')) {
          <span class="error-message" role="alert" aria-live="assertive">
            {{ "forgotUserPassword.invalidEmail" | cxTranslate }}
          </span>
        }
        @if (
          (passwordResetForm.get('email').hasError('required') &&
          passwordResetForm.get('email').touched) ||
          (passwordResetRequired &&
          !passwordResetForm.get('email').hasError('pattern'))
          ) {
          <span class="error-message" role="alert" aria-live="assertive">{{ "forgotUserPassword.EmailRequired" | cxTranslate }}
          </span>
        }
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container pt-3 captcha-x">
        <!-- re-captcha
        *ngIf="recaptchaEnabled"
        [siteKey]="siteKey"
        formControlName="captchaToken"
        (resolved)="showCaptchaErrorMsg = false"
        ></re-captcha -->
        <div id="recaptcha-container"></div>

        <br/>
        @if (showCaptchaErrorMsg) {
          <span class="defaultMessage" role="alert" aria-live="assertive">
            {{ "userRegistration.accountInformation.requiredMsg" | cxTranslate }}
          </span>
        }
      </div>
      <div class="Fields-btn-group">
        <button type="submit" class="btn-primary">
          {{ "forgotUserPassword.continue" | cxTranslate }}
        </button>
      </div>
    </div>
  </form>
  <br />
</div>